import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusZoomOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFocusZoomOut"><Path d="M9 3H3V9H5V5H9V3Z" fill="currentColor"/><Path d="M21 3H15V5H19V9H21V3Z" fill="currentColor"/><Path d="M5 19V15H3V21H9V19H5Z" fill="currentColor"/><Path d="M21 21V15H19V19H15V21H21Z" fill="currentColor"/><Path d="M13 11V8H11V11H8V13H11V16H13V13H16V11H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFocusZoomOut;
